import React from "react";
import useTitle from "../hooks/useTitle";
import { PiShareDuotone } from "react-icons/pi";

export default function Shared() {
  useTitle("Vizta Shared");
  return (
    <div className="flex items-center justify-center h-screen  ml-[5%] ">
      <div className="flex flex-col items-center">
        <PiShareDuotone className="text-9xl" />
        <h1 className="text-2xl font-medium text-gray-700 mt-4">
          Items shared with you will be stored here.
        </h1>
        <p className="text-gray-500 mt-2">
          Get quick access to items shared with you—no need to search your inbox
          for a link.
        </p>
      </div>
    </div>
  );
}
